import { useRef } from 'react';
import { Link, Navigate, useSearchParams } from 'react-router-dom';
import { conMovimiento, entrada, revelar, useGSAP } from '../animaciones';
import { SelectorDeIdioma, useIdioma } from '../idioma';
import { useSesion } from '../sesion';

/** Lo que hace IGOR, en el orden del menú: saber → planear → producir → publicar. */
const PASOS: [string, string][] = [
  ['Tu marca', 'Nos cuentas de tu negocio y armamos tu estrategia, el diagnóstico de tus redes y tu identidad visual.'],
  ['Tu mes', 'Planeamos qué publicar cada día y en qué red, con los textos listos.'],
  ['Diseño gráfico', 'Historias, carruseles e imágenes con tus colores, tu logo y tus fotos.'],
  ['Video', 'Videos con presentadora, historias con escenas o textos que se mueven, sin tener que grabar.'],
  ['Publicar y medir', 'Programamos todo en tus redes y te mostramos cómo le va a cada publicación.'],
];

/** La portada solo es para quien no ha entrado: con sesión, directo a sus marcas. */
export function Portada() {
  const { sesion, cargando } = useSesion();
  const { t } = useIdioma();
  const raiz = useRef<HTMLElement>(null);
  const [consulta] = useSearchParams();
  useGSAP(
    () =>
      conMovimiento(() => {
        revelar('.portada-titulo', { por: 'letras', cada: 0.07 });
        revelar('.portada-lema', { por: 'palabras', retraso: 0.35, cada: 0.04 });
        revelar('.portada-frase-grande', { por: 'lineas', retraso: 0.55 });
        entrada('.portada-frase, .portada-caja .btn, .portada-caja .apunte', { retraso: 0.85, cada: 0.1 });
      }),
    { scope: raiz },
  );
  if (!cargando && sesion) return <Navigate to="/marcas" replace />;
  return (
    <main className="portada portada-larga" ref={raiz}>
      <div className="idioma-flotante"><SelectorDeIdioma /></div>
      <div className="portada-caja portada-heroe">
        {consulta.get('cuenta') === 'borrada' && <p className="aviso" role="status">{t('Tu cuenta y todo lo tuyo se borraron. Gracias por haber probado IGOR.')}</p>}
        <h1 className="portada-titulo">IGOR</h1>
        <p className="portada-lema">{t('Ideas que Generan Oportunidades Reales')}</p>
        <h2 className="portada-frase-grande">{t('Tu equipo de contenido con IA, listo cada mes')}</h2>
        <p className="portada-frase">{t('Diseños y videos para tus redes, sin complicarte. Hecho para emprendedores de Latinoamérica.')}</p>
        {sesion ? (
          <Link className="btn" to="/marcas">{t('Entrar')}</Link>
        ) : (
          <span className="fila-acciones" style={{ justifyContent: 'center' }}>
            <Link className="btn" to="/registro">{t('Crea tu cuenta gratis')}</Link>
            <Link className="btn claro" to="/entrar">{t('Ya tengo cuenta')}</Link>
          </span>
        )}
        <p className="apunte">{t('Con tu correo, con Google o con tu contraseña.')}</p>
      </div>

      {/* Qué es IGOR, a la vista sin entrar (08-10-2026): lo pide Google para la pantalla de «Entrar con Google». */}
      <section className="portada-que" aria-labelledby="que-hace">
        <h2 id="que-hace" className="portada-sub">{t('Qué hace IGOR por tu negocio')}</h2>
        <p className="portada-frase">{t('IGOR es una plataforma que te guía paso a paso, con inteligencia artificial, para tener el contenido de tus redes sociales listo cada mes.')}</p>
        <ol className="portada-pasos">
          {PASOS.map(([titulo, texto], i) => (
            <li key={titulo} className="tarjeta"><span className="portada-num num">{i + 1}</span><b>{t(titulo)}</b><span>{t(texto)}</span></li>
          ))}
        </ol>
        <p className="portada-frase">{t('Empiezas gratis y sin tarjeta. Tus datos se usan solo para hacer tu contenido: nunca los vendemos.')}</p>
      </section>

      <footer className="portada-pie">
        <span>IGOR · Ideas en Movimiento</span>
        <a href="/privacidad">{t('Privacidad')}</a>
        <a href="/terminos">{t('Términos')}</a>
        <a href="mailto:quokka@ideasenmovimiento.com.co">quokka@ideasenmovimiento.com.co</a>
      </footer>
    </main>
  );
}
